var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "scroll",
      attrs: { elevation: "0", height: _vm.winsize.height - 145 },
    },
    [
      _c("utils-popup-input-text", { ref: "utils-popup-input-text" }),
      _c("utils-popup-select-character", {
        ref: "utils-popup-select-character",
      }),
      _c("utils-popup-select-emotion", { ref: "utils-popup-select-emotion" }),
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-card",
            { attrs: { elevation: "0", outlined: "", width: "100%" } },
            [
              _c(
                "v-card-actions",
                { staticClass: "ma-2 pa-0" },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "pa-2 text-pre-wrap",
                      attrs: { outlined: "", elevation: "0", width: "100%" },
                    },
                    [
                      _c("h4", [
                        _vm._v(
                          _vm._s(
                            _vm.talkMessage == ""
                              ? "Talk message"
                              : _vm.talkMessage
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "ma-0 pa-0 mt-7" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "green white--text ml-2 mr-2 mt-n5 mb-2 pr-5",
                      attrs: { elevation: "0" },
                      on: {
                        click: function ($event) {
                          return _vm.addText()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-plus"),
                      ]),
                      _vm._v("Add Existing Talk"),
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass:
                        "orange white--text ml-0 mr-5 mt-n5 mb-2 pr-5",
                      attrs: { elevation: "0" },
                      on: {
                        click: function ($event) {
                          return _vm.addEmpty()
                        },
                      },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-folder-plus-outline"),
                      ]),
                      _vm._v("New Talk"),
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue white--text ml-2 mr-2 mt-n5 mb-2",
                      attrs: { elevation: "0" },
                      on: { click: _vm.copyToClipboard },
                    },
                    [
                      _c("v-icon", { staticClass: "mr-2" }, [
                        _vm._v("mdi-clipboard-check-outline"),
                      ]),
                      _vm._v("Copy to Clipboard (for tools)"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(this.phrases, function (phrase) {
        return _c(
          "v-card",
          {
            key: phrase.hash,
            staticClass: "ma-0 pa-0",
            attrs: { elevation: "0" },
          },
          [
            _c(
              "v-card-actions",
              { staticClass: "ma-0 pa-0 mt-1" },
              [
                _c(
                  "v-card",
                  { attrs: { elevation: "0", outlined: "", width: "100%" } },
                  [
                    _c(
                      "v-card-actions",
                      { staticClass: "ma-0 pa-2" },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressAdd(phrase, true)
                              },
                            },
                          },
                          [
                            _vm._v("Add upper"),
                            _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("mdi-chevron-up"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: { elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressAdd(phrase, false)
                              },
                            },
                          },
                          [
                            _vm._v("Add under"),
                            _c("v-icon", { attrs: { color: "green" } }, [
                              _vm._v("mdi-chevron-down"),
                            ]),
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            staticClass: "orange white--text",
                            attrs: { elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressSelectCharacter(phrase)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-account-sync-outline")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            staticClass: "blue white--text",
                            attrs: { elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressSelectEmotion(phrase)
                              },
                            },
                          },
                          [
                            _c("v-icon", [
                              _vm._v("mdi-emoticon-happy-outline"),
                            ]),
                          ],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            class:
                              phrase.place == 0
                                ? "green white--text"
                                : " grey--text",
                            attrs: { outlined: "", elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onUpdatePlace(phrase, 0)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-format-align-left")])],
                          1
                        ),
                        _c(
                          "v-btn",
                          {
                            class:
                              phrase.place == 1
                                ? "green white--text"
                                : " grey--text",
                            attrs: { outlined: "", elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onUpdatePlace(phrase, 1)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-format-align-right")])],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            staticClass: "ml-2",
                            attrs: { elevation: "0", outlined: "" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "darken-1 white",
                                attrs: { elevation: "0" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onUpdateSkip(phrase)
                                  },
                                },
                              },
                              [
                                _c("v-icon", { staticClass: "mr-1" }, [
                                  _vm._v(
                                    _vm._s(
                                      phrase.skip == 0
                                        ? "mdi-checkbox-blank-outline"
                                        : "mdi-checkbox-intermediate"
                                    )
                                  ),
                                ]),
                                _vm._v("Skip"),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        _c(
                          "v-btn",
                          {
                            attrs: { icon: "", elevation: "0" },
                            on: {
                              click: function ($event) {
                                return _vm.onPressDelete(phrase)
                              },
                            },
                          },
                          [
                            _c("v-icon", { attrs: { color: "red" } }, [
                              _vm._v("mdi-delete"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "ma-0 pa-3" },
                      [
                        _c("v-spacer", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: phrase.place == 1,
                              expression: "phrase.place == 1",
                            },
                          ],
                        }),
                        _c(
                          "v-card",
                          { attrs: { elevation: "0" } },
                          [
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0" },
                              [
                                _c(
                                  "v-card",
                                  {
                                    attrs: {
                                      width: "200px",
                                      height: "200px",
                                      elevation: "0",
                                    },
                                  },
                                  [
                                    _vm.getUrl(phrase) == undefined
                                      ? _c("v-progress-circular", {
                                          staticStyle: {
                                            "margin-top": "85px",
                                            "margin-left": "85px",
                                          },
                                          attrs: {
                                            indeterminate: "",
                                            color: "orange",
                                          },
                                        })
                                      : _c("v-img", {
                                          style: {
                                            transform:
                                              "scaleX(" +
                                              (phrase.place == 0 ? 1 : -1) +
                                              ")",
                                          },
                                          attrs: {
                                            "max-width": "200",
                                            src: _vm.getUrl(phrase),
                                          },
                                        }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-card-actions",
                              { staticClass: "ma-0 pa-0 mt-n2" },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "pa-1 text-center white--text",
                                    attrs: {
                                      elevation: "0",
                                      color: "orange",
                                      width: "100%",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.getHeroName(phrase.code)) +
                                        " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-card-actions",
                      { staticClass: "ma-0 pa-0 ml-2 mr-2 mb-2" },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "pa-3 text-center",
                            attrs: {
                              elevation: "0",
                              color: "orange lighten-4",
                              width: "100%",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", elevation: "0" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onPressEditText(phrase)
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-pencil-outline")])],
                              1
                            ),
                            _vm._v(" " + _vm._s(phrase.text) + " "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    phrase.skip != 0
                      ? _c(
                          "v-card-actions",
                          { staticClass: "ma-3 pa-0" },
                          [
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "white--text",
                                attrs: { elevation: "0", color: "blue" },
                              },
                              [_vm._v("Skip")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }